module.exports = __webpack_public_path__ + "static/media/linePink.bbbaaddb.svg";